var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cars"},[_c('div',{staticClass:"approve-box text-c"},[_c('img',{staticClass:"approve",attrs:{"src":_vm.img.approve}}),_c('div',{staticClass:"f-16 f-w"},[_vm._v("手机号绑定成功")])])])}
var staticRenderFns = []

export { render, staticRenderFns }